// Arabic (MSA) translations. Keys are the natural English source strings.
// Missing keys gracefully fall back to English. Prices/phone numbers keep Western digits.
const ar = {
  // ---------- Language toggle ----------
  "العربية": "العربية",

  // ---------- Header / nav ----------
  "Rent a Car": "استئجار سيارة",
  "Daily & Weekly Rental": "الإيجار اليومي والأسبوعي",
  "Monthly Rentals & Subscription": "الإيجار الشهري والاشتراك",
  "International Rentals": "الإيجار الدولي",
  "Why Europcar": "لماذا يوروبكار",
  "Our Fleet": "أسطولنا",
  "Our Network & Branches": "شبكتنا وفروعنا",
  "Locations & Branch Finder": "المواقع ودليل الفروع",
  "The Europcar Promise": "وعد يوروبكار",
  "Renter's Guide": "دليل المستأجر",
  "Partner With Us": "كن شريكاً معنا",
  "Offers": "العروض",
  "Blog": "المدونة",
  "Help": "المساعدة",
  "Help & FAQs": "المساعدة والأسئلة الشائعة",
  "Contact Us": "اتصل بنا",
  "About": "من نحن",
  "About Us": "من نحن",
  "Account & Vehicle": "الحساب والمركبة",
  "Account / Vehicle": "الحساب / المركبة",
  "Sign Out": "تسجيل الخروج",
  "Sign In": "تسجيل الدخول",
  "Dubai & Northern Emirates": "دبي والإمارات الشمالية",

  // ---------- Footer ----------
  "Dubai & Northern Emirates. Daily, weekly and monthly rentals across the UAE — delivered to your door or ready at 9 branches.":
    "دبي والإمارات الشمالية. إيجارات يومية وأسبوعية وشهرية في جميع أنحاء الإمارات — تُوصَّل إلى بابك أو جاهزة للاستلام من 9 فروع.",
  "24/7 Roadside — 800 364": "مساعدة على الطريق على مدار الساعة — 800 364",
  "9 branches across 4 emirates": "9 فروع في 4 إمارات",
  "AED 3.65M third-party cover + CDW": "تغطية للطرف الثالث بقيمة 3.65 مليون درهم + إعفاء أضرار الاصطدام",
  "Company": "الشركة",
  "Offers & Promotions": "العروض والترويجات",
  "Blog & Driving Guides": "المدونة وأدلة القيادة",
  "Help & Support": "المساعدة والدعم",
  "Careers": "الوظائف",
  "© 2026 Europcar Dubai & Northern Emirates. Demo platform — payments simulated. This site uses essential cookies only (sign-in session).":
    "© 2026 يوروبكار دبي والإمارات الشمالية. منصة تجريبية — المدفوعات محاكاة. يستخدم هذا الموقع ملفات تعريف الارتباط الأساسية فقط (جلسة تسجيل الدخول).",
  "Terms & Conditions": "الشروط والأحكام",
  "Privacy Policy": "سياسة الخصوصية",
  "Cookie Policy": "سياسة ملفات تعريف الارتباط",
  "Minimum driver age 21 · Prices shown are Pay Now incl. 5% VAT · \"Or similar\" model policy":
    "الحد الأدنى لسن السائق 21 · الأسعار المعروضة للدفع الآن شاملة 5% ضريبة القيمة المضافة · سياسة \"أو ما يماثلها\" للطُرز",

  // ---------- Home hero ----------
  "Your keys to the Emirates": "مفاتيحك إلى الإمارات",
  "Daily and weekly rentals from 1 day, monthly from AED 1,537 incl. VAT. Delivered to your door in as little as 4 hours — free cancellation until 24 hours before pickup.":
    "إيجارات يومية وأسبوعية بدءاً من يوم واحد، وشهرية ابتداءً من 1,537 درهم شاملة الضريبة. تُوصَّل إلى بابك خلال 4 ساعات فقط — مع إلغاء مجاني حتى 24 ساعة قبل الاستلام.",

  // ---------- Home: trust cards ----------
  "24/7 Roadside": "مساعدة على الطريق 24/7",
  "Assistance anywhere in the UAE, any hour.": "مساعدة في أي مكان بالإمارات وفي أي ساعة.",
  "No Hidden Charges": "بدون رسوم خفية",
  "Deposit, VAT and fees disclosed before you pay.": "التأمين والضريبة والرسوم معلنة قبل الدفع.",
  "Youngest Fleet": "أحدث أسطول",
  "53 models, 2025–2026 model years.": "53 طرازاً من موديلات 2025–2026.",
  "AED 3.65M Cover": "تغطية 3.65 مليون درهم",
  "Third-party liability + CDW included on every rental.": "تغطية مسؤولية الطرف الثالث + إعفاء أضرار الاصطدام مشمولة في كل إيجار.",

  // ---------- Home: price ladder ----------
  "Simple, honest pricing": "تسعير بسيط وصادق",
  "All prices shown are Pay Now and include 5% VAT. Rent with No Deposit or Security blocking — available for a nominal fee based on vehicle group and tenure.":
    "جميع الأسعار المعروضة للدفع الآن وتشمل 5% ضريبة القيمة المضافة. استأجر بدون تأمين أو حجز مبلغ ضمان — متاح مقابل رسم رمزي حسب فئة المركبة ومدة الإيجار.",
  "Daily": "يومي",
  "Weekly": "أسبوعي",
  "Monthly": "شهري",
  "AED 78": "78 درهم",
  "AED 73": "73 درهم",
  "AED 1,537": "1,537 درهم",
  "per day incl. VAT": "لليوم شامل الضريبة",
  "per month incl. VAT": "للشهر شامل الضريبة",
  "1–6 days · full flexibility": "1–6 أيام · مرونة كاملة",
  "7–21 days · weekly band rate": "7–21 يوماً · سعر الشريحة الأسبوعية",
  "22+ days · maintenance included": "22+ يوماً · تشمل الصيانة",
  "from": "ابتداءً من",
  "Choose": "اختر",

  // ---------- Home: add-ons ----------
  "Tailor your rental": "خصّص إيجارك",
  "Every rental already includes CDW and AED 3.65M third-party cover. These popular extras take it further — add any of them in one tap at booking.":
    "كل إيجار يشمل بالفعل إعفاء أضرار الاصطدام وتغطية طرف ثالث بقيمة 3.65 مليون درهم. هذه الإضافات الشائعة تمنحك المزيد — أضِف أياً منها بنقرة واحدة عند الحجز.",
  "Super Collision Damage Waiver": "إعفاء أضرار الاصطدام الفائق",
  "No-Deposit Rental": "إيجار بدون تأمين",
  "Additional Driver": "سائق إضافي",
  "Child & Baby Seats": "مقاعد الأطفال والرُضّع",
  "from AED 35/day": "ابتداءً من 35 درهم/يوم",
  "from AED 10/day": "ابتداءً من 10 درهم/يوم",
  "from AED 25/day": "ابتداءً من 25 درهم/يوم",
  "+ VAT": "+ ضريبة القيمة المضافة",
  "incl. VAT": "شامل الضريبة",
  "Short-Term Rental": "تأجير قصير الأمد",
  "Monthly Rental": "تأجير شهري",
  "Short-Term": "قصير الأمد",
  "Book your Short-Term Rental": "احجز تأجيرك قصير الأمد",
  "Book your Monthly Rental": "احجز تأجيرك الشهري",
  "Most added": "الأكثر إضافة",
  "Bring your damage excess to zero — hand the keys back without a second thought, whatever the road threw at you.":
    "اجعل مبلغ التحمّل صفراً — سلّم المفاتيح دون قلق مهما واجهت على الطريق.",
  "Skip the AED 1,500+ card hold entirely. Your credit limit stays yours for the trip itself.":
    "تجاوز حجز البطاقة بقيمة 1,500 درهم أو أكثر تماماً. يبقى حد بطاقتك متاحاً لرحلتك.",
  "Share long drives legally and insured — add a second driver in seconds at booking.":
    "شارِك القيادة في الرحلات الطويلة بشكل قانوني ومؤمَّن — أضِف سائقاً ثانياً خلال ثوانٍ عند الحجز.",
  "Safety-certified seats for every age, fitted and ready — required by UAE law for under-4s.":
    "مقاعد معتمدة للسلامة لكل الأعمار، مركّبة وجاهزة — إلزامية بموجب قانون الإمارات لمن هم دون 4 سنوات.",

  // ---------- Home: fleet strip ----------
  "Our fleet": "أسطولنا",
  "53 models across 24 rental groups — you always get your chosen model or similar.":
    "53 طرازاً ضمن 24 مجموعة إيجار — تحصل دائماً على الطراز الذي اخترته أو ما يماثله.",
  "Browse all 53 vehicles": "تصفّح جميع الـ 53 مركبة",
  "or similar": "أو ما يماثلها",

  // ---------- Home: monthly teaser ----------
  "Monthly rentals & subscription": "الإيجار الشهري والاشتراك",
  "From AED 1,537/month incl. VAT · 22+ days": "ابتداءً من 1,537 درهم/شهر شامل الضريبة · 22+ يوماً",
  "Terms of 1, 3, 6 or 9 months — save up to 15% on longer terms":
    "مدد 1 أو 3 أو 6 أو 9 أشهر — وفّر حتى 15% على المدد الأطول",
  "3,000 or 5,000 km per month · model year 2025 or 2026":
    "3,000 أو 5,000 كم شهرياً · موديل 2025 أو 2026",
  "Maintenance, registration and 24/7 roadside included":
    "تشمل الصيانة والتسجيل والمساعدة على الطريق على مدار الساعة",
  "Rent with No Deposit or Security blocking for a nominal fee":
    "استأجر بدون تأمين أو حجز مبلغ ضمان مقابل رسم رمزي",
  "Explore monthly plans": "استكشف الخطط الشهرية",

  // ---------- Home: why europcar teaser ----------
  "Our Network": "شبكتنا",
  "53 vehicles from city runabouts to the Land Cruiser — staged across Dubai Marina, the dunes and the Hajar mountains.":
    "53 مركبة من سيارات المدينة الصغيرة إلى لاند كروزر — بمشاهد من مرسى دبي والكثبان وجبال الحجر.",
  "9 branches across 4 emirates, including 24/7 desks at Dubai Airport T1, T3 and Sharjah Airport — plus delivery in all six.":
    "9 فروع في 4 إمارات، تشمل مكاتب على مدار الساعة في مطار دبي المبنى 1 و3 ومطار الشارقة — مع خدمة التوصيل في الإمارات الست جميعها.",
  "Transparent pricing, a car that's ready when we say it is, and people who answer at 3am.":
    "تسعير شفّاف، وسيارة جاهزة في موعدها، وفريق يردّ عليك حتى الثالثة فجراً.",
  "Learn more": "اعرف المزيد",

  // ---------- Home: FAQs ----------
  "Good to know": "معلومات مفيدة",
  "What is the difference between Daily/Weekly and Monthly rentals?":
    "ما الفرق بين الإيجار اليومي/الأسبوعي والإيجار الشهري؟",
  "Daily and weekly rentals cover 1–21 days with full flexibility. From 22 days, our monthly rentals cost less per day, include maintenance, and offer 1/3/6/9-month terms with savings on longer commitments.":
    "يغطي الإيجار اليومي والأسبوعي من 1 إلى 21 يوماً بمرونة كاملة. اعتباراً من 22 يوماً، تكون إيجاراتنا الشهرية أقل تكلفة يومياً وتشمل الصيانة وتوفّر مدداً من 1/3/6/9 أشهر مع توفير على الالتزامات الأطول.",
  "Can I rent without a security deposit?": "هل يمكنني الاستئجار بدون تأمين ضمان؟",
  "Yes — rent with No Deposit or Security blocking, available for a nominal fee based on vehicle group and tenure. Otherwise, a credit-card pre-authorization or debit-card deposit applies at handover.":
    "نعم — استأجر بدون تأمين أو حجز مبلغ ضمان، وهو متاح مقابل رسم رمزي حسب فئة المركبة ومدة الإيجار. وإلا يُطبَّق حجز مسبق على بطاقة الائتمان أو مبلغ ضمان على بطاقة الخصم عند التسليم.",
  "How fast can you deliver a car to me?": "ما مدى سرعة توصيل السيارة إليّ؟",
  "Deliveries run 09:00–21:00 daily. We need 3 hours notice in Dubai & Sharjah and 6 hours in Ajman, UAQ, RAK and Fujairah. Branch pickup is ready 3 hours after booking.":
    "تتم عمليات التوصيل يومياً من 09:00 إلى 21:00. نحتاج إلى مهلة 3 ساعات في دبي والشارقة و6 ساعات في عجمان وأم القيوين ورأس الخيمة والفجيرة. ويكون الاستلام من الفرع جاهزاً بعد 3 ساعات من الحجز.",
  "What documents do I need?": "ما المستندات التي أحتاجها؟",
  "UAE residents: Emirates ID and a UAE driving license. Tourists: passport, home license and an International Driving Permit where applicable. You upload them after booking — takes two minutes.":
    "لمقيمي الإمارات: الهوية الإماراتية ورخصة قيادة إماراتية. للسياح: جواز السفر ورخصة بلدك ورخصة قيادة دولية عند اللزوم. تُرفَع بعد الحجز — وتستغرق دقيقتين.",
  "All questions answered in Help & Support →": "كل الأسئلة مُجابة في المساعدة والدعم ←",

  // ---------- Home: journal / B2B ----------
  "From the journal": "من المدوّنة",
  "UAE driving guides, rental wisdom and the case for flexibility.":
    "أدلة القيادة في الإمارات، ونصائح الإيجار، ودواعي المرونة.",
  "View all articles": "عرض كل المقالات",
  "min read": "دقيقة قراءة",
  "Partner with us": "كن شريكاً معنا",
  "Dedicated rates, volume booking and priority support for 8 partner categories.":
    "أسعار مخصّصة، وحجوزات بالجملة، ودعم ذو أولوية لـ 8 فئات من الشركاء.",
  "Hotels & Hospitality": "الفنادق والضيافة",
  "Travel & Tourism": "السفر والسياحة",
  "Digital Aggregators": "المنصّات الرقمية",
  "Corporate Mobility": "التنقّل المؤسسي",
  "Insurance & Roadside": "التأمين والمساعدة على الطريق",
  "Loyalty Programmes": "برامج الولاء",
  "Affiliate Sales": "المبيعات بالعمولة",
  "Connect With Us": "تواصل معنا",

  // ---------- Home: TrustStrip ----------
  "models in the fleet": "طرازاً في الأسطول",
  "branches across 4 emirates": "فروع في 4 إمارات",
  "happy customers": "عميل سعيد",

  // ---------- Home: HowItWorks ----------
  "Rent in four easy steps": "استأجر في أربع خطوات سهلة",
  "From search to keys — most customers finish in under three minutes.":
    "من البحث إلى المفاتيح — ينهي معظم العملاء العملية في أقل من ثلاث دقائق.",
  "Choose your plan": "اختر خطتك",
  "Daily, weekly or monthly — pick dates and how you'd like your car.":
    "يومي أو أسبوعي أو شهري — اختر التواريخ وطريقة استلام سيارتك.",
  "Select your car": "اختر سيارتك",
  "53 models by rental group, real rates incl. VAT, zero-deposit available.":
    "53 طرازاً حسب مجموعة الإيجار، بأسعار حقيقية شاملة الضريبة، مع خيار بدون تأمين.",
  "Verify documents": "تحقّق من المستندات",
  "After you book, not before — upload from your phone in two minutes.":
    "بعد الحجز وليس قبله — ارفعها من هاتفك في دقيقتين.",
  "Delivered or picked up": "توصيل أو استلام",
  "To your door in as little as 4 hours, or collect at 9 branches.":
    "إلى بابك خلال 4 ساعات فقط، أو استلمها من 9 فروع.",

  // ---------- Home: SelfServiceStrip ----------
  "Your rental, your rules": "إيجارك، بشروطك",
  "Extend your rental, swap your car, download invoices, book a service — log into your account and make the change in a few clicks.":
    "مدّد إيجارك، بدّل سيارتك، حمّل الفواتير، احجز خدمة — سجّل الدخول إلى حسابك وأجرِ التغيير بنقرات قليلة.",
  "Extend your rental": "تمديد الإيجار",
  "Swap your car": "تبديل السيارة",
  "Download invoices": "تحميل الفواتير",
  "Book a service": "حجز خدمة",

  // ---------- Home: LifecycleStrip ----------
  "With you at every step": "معك في كل خطوة",
  "Booking is just the start. Here's how we look after you before, during and after every rental.":
    "الحجز مجرد بداية. إليك كيف نعتني بك قبل كل إيجار وأثناءه وبعده.",
  "Before your rental": "قبل إيجارك",
  "During your rental": "أثناء إيجارك",
  "After your rental": "بعد إيجارك",
  "Doorstep delivery in as little as 4 hours — or pick up at 9 branches":
    "توصيل إلى الباب خلال 4 ساعات فقط — أو الاستلام من 9 فروع",
  "Digital check-in & document upload from your phone in 2 minutes":
    "تسجيل وصول رقمي ورفع المستندات من هاتفك في دقيقتين",
  "Flight tracking on airport pickups — land late, your car still waits":
    "تتبّع الرحلات عند الاستلام من المطار — تأخّر هبوطك وستبقى سيارتك بانتظارك",
  "24/7 roadside assistance anywhere in the UAE — call 800 364":
    "مساعدة على الطريق على مدار الساعة في أي مكان بالإمارات — اتصل بـ 800 364",
  "Extend, swap your car or book a service from your account":
    "مدّد أو بدّل سيارتك أو احجز خدمة من حسابك",
  "Accident? Report online with photos — we handle the rest":
    "حادث؟ أبلِغ عبر الإنترنت بالصور — ونحن نتولّى الباقي",
  "Download invoices & rental agreements any time":
    "حمّل الفواتير وعقود الإيجار في أي وقت",
  "Deposit released within 21 working days — tracked in your account":
    "يُسترَد مبلغ الضمان خلال 21 يوم عمل — مع تتبّعه في حسابك",
  "Tolls & fines itemised transparently — dispute in one click":
    "الرسوم والمخالفات مفصّلة بشفافية — اعترض بنقرة واحدة",

  // ---------- Home: ReviewsCarousel ----------
  "Rated by real drivers": "تقييمات من سائقين حقيقيين",
  "reviews from Europcar UAE customers": "تقييمات من عملاء يوروبكار الإمارات",
  "today": "اليوم",

  // ---------- BookingWidget ----------
  "Daily / Weekly": "يومي / أسبوعي",
  "Monthly (22+ days)": "شهري (22+ يوماً)",
  "Start date *": "تاريخ البدء *",
  "Pick-up date *": "تاريخ الاستلام *",
  "Time *": "الوقت *",
  "Drop-off date *": "تاريخ التسليم *",
  "Flying in? (optional)": "قادم بالطائرة؟ (اختياري)",
  "Flight number, e.g. EK202": "رقم الرحلة، مثال EK202",
  "We track your flight — your car is ready even if you land late, at no extra charge.":
    "نتتبّع رحلتك — سيارتك جاهزة حتى لو تأخّر هبوطك، دون أي رسوم إضافية.",
  "I am above the age of 21": "عمري أكبر من 21 عاماً",
  "(minimum rental age — you can view rates first, we'll confirm before booking)":
    "(الحد الأدنى لسن الإيجار — يمكنك عرض الأسعار أولاً، وسنؤكّد قبل الحجز)",
  "View monthly offers": "عرض العروض الشهرية",
  "Search vehicles": "ابحث عن مركبة",
  "Choose a time": "اختر وقتاً",
  "No times are available on your pick-up date — we've suggested the next day. Pick an available time to continue.":
    "لا تتوفّر أوقات في تاريخ الاستلام — اقترحنا اليوم التالي. اختر وقتاً متاحاً للمتابعة.",
  "Check your dates": "تحقّق من التواريخ",
  "The drop-off must be after the pick-up. Let's fix this — adjust your return date or time.":
    "يجب أن يكون التسليم بعد الاستلام. لنصحّح ذلك — عدّل تاريخ أو وقت الإرجاع.",

  // ---------- Login ----------
  "Welcome back.": "مرحباً بعودتك.",
  "Create your account.": "أنشئ حسابك.",
  "Sign Up": "إنشاء حساب",
  "Full name": "الاسم الكامل",
  "Phone (optional)": "الهاتف (اختياري)",
  "Email": "البريد الإلكتروني",
  "Password": "كلمة المرور",
  "Forgot your password?": "هل نسيت كلمة المرور؟",
  "Create Account": "إنشاء حساب",
  "or": "أو",
  "Continue with Google": "المتابعة عبر Google",
  "Your rentals, in one place.": "إيجاراتك في مكان واحد.",
  "Extend, swap, download invoices and manage every charge — self-service, no phone queue.":
    "مدّد، بدّل، حمّل الفواتير، وأدِر كل رسم — خدمة ذاتية بلا انتظار على الهاتف.",
  "53-model fleet with zero-deposit options": "أسطول من 53 طرازاً مع خيارات بدون تأمين",
  "Delivery in as little as 4 hours in Dubai & Sharjah": "توصيل خلال 4 ساعات فقط في دبي والشارقة",
  "AED 3.65M third-party cover + CDW on every rental":
    "تغطية طرف ثالث بقيمة 3.65 مليون درهم + إعفاء أضرار الاصطدام في كل إيجار",
  "No paperwork before you book — documents upload after confirmation.":
    "لا أوراق قبل الحجز — تُرفَع المستندات بعد التأكيد.",
  "If this email is new, your account is ready — please sign in. Already have an account? Use 'Forgot your password?'.":
    "إذا كان هذا البريد جديداً، فحسابك جاهز — يرجى تسجيل الدخول. لديك حساب بالفعل؟ استخدم \"هل نسيت كلمة المرور؟\".",
  "By continuing you accept the": "بالمتابعة أنت توافق على",
  "rental terms": "شروط الإيجار",
  ". Minimum driver age 21.": ". الحد الأدنى لسن السائق 21 عاماً.",

  // ---------- Booking: HandoverPicker ----------
  "Collect from a branch": "الاستلام من فرع",
  "Deliver to me": "التوصيل إليّ",
  "Pickup branch *": "فرع الاستلام *",
  "Emirate of delivery *": "إمارة التوصيل *",
  "Vehicle return": "إرجاع المركبة",
  "We collect it back from your delivery location": "نستلمها منك من موقع التوصيل",
  "I'll return it to a Europcar branch": "سأُعيدها إلى فرع يوروبكار",
  "{{h}}h notice": "مهلة {{h}} ساعات",
  "Delivery address details will be taken at checkout. Delivery in Dubai & Sharjah is included on monthly rentals; a zone fee applies in other emirates.":
    "تُؤخذ تفاصيل عنوان التوصيل عند الدفع. التوصيل في دبي والشارقة مشمول في الإيجارات الشهرية؛ وتُطبَّق رسوم منطقة في الإمارات الأخرى.",
  "Delivery address details will be taken at checkout. For daily or weekly rentals, a nominal delivery fee applies.":
    "تُؤخذ تفاصيل عنوان التوصيل عند الدفع. تُطبَّق رسوم توصيل رمزية على الإيجارات اليومية أو الأسبوعية.",
  "Dubai": "دبي",
  "Sharjah": "الشارقة",
  "Ajman": "عجمان",
  "Umm Al Quwain": "أم القيوين",
  "Ras Al Khaimah": "رأس الخيمة",
  "Fujairah": "الفجيرة",
  "Abu Dhabi": "أبوظبي",

  // ---------- Booking: TimeSlotSelect ----------
  "Loading times…": "جارٍ تحميل الأوقات…",
  "No times available on this date — try the next day or a nearby branch.":
    "لا تتوفّر أوقات في هذا التاريخ — جرّب اليوم التالي أو فرعاً قريباً.",

  // ---------- Booking: modals ----------
  "Let's fix this": "لنُصلح ذلك",
  "Got it": "حسناً",
  "A better rate for {{days}} days": "سعر أفضل لـ {{days}} يوماً",
  "Rentals of 22 days or more qualify as a monthly rental — and our Monthly Rentals page has the best offers for your dates. Your dates and location carry over automatically.":
    "الإيجارات من 22 يوماً فأكثر تُعدّ إيجاراً شهرياً — وصفحة الإيجار الشهري لدينا تضم أفضل العروض لتواريخك. وتنتقل تواريخك وموقعك تلقائياً.",
  "Move to Monthly booking": "الانتقال إلى الحجز الشهري",
  "Continue with daily rate": "المتابعة بالسعر اليومي",
  "One quick confirmation": "تأكيد سريع",
  "The minimum rental age is 21. Please confirm before we lock in your vehicle.":
    "الحد الأدنى لسن الإيجار 21 عاماً. يرجى التأكيد قبل أن نحجز مركبتك.",
  "Continue to booking": "المتابعة إلى الحجز",

  // ---------- Results page ----------
  "{{n}} days": "{{n}} أيام",
  "Adjust my search — everything is saved": "عدّل بحثي — كل شيء محفوظ",
  "You're viewing live rates. We'll ask you to confirm you're above 21 when you select a vehicle.":
    "أنت تشاهد أسعاراً مباشرة. سنطلب منك تأكيد أنّ عمرك فوق 21 عاماً عند اختيار مركبة.",
  "Every rental includes": "كل إيجار يشمل",
  "CDW + AED 3.65M third-party cover": "إعفاء أضرار الاصطدام + تغطية طرف ثالث 3.65 مليون درهم",
  "Unlimited km within UAE": "كيلومترات غير محدودة داخل الإمارات",
  "24/7 roadside — 800 364": "مساعدة على الطريق 24/7 — 800 364",
  "24/7 roadside assistance — 800 364": "مساعدة على الطريق 24/7 — 800 364",
  "Free cancellation until 24h before pickup": "إلغاء مجاني حتى 24 ساعة قبل الاستلام",
  "Smart-money tip:": "نصيحة توفير:",
  "add {{n}} more days and you unlock the weekly band rate — often a lower total for more time with the car.":
    "أضِف {{n}} أيام أخرى لتحصل على سعر الشريحة الأسبوعية — غالباً بإجمالي أقل ووقت أطول مع السيارة.",
  "Adjust dates": "تعديل التواريخ",
  "All": "الكل",
  "Economy": "اقتصادية",
  "Sedans": "سيدان",
  "SUVs & Crossovers": "الدفع الرباعي والكروس أوفر",
  "7-Seaters & MPV": "7 مقاعد والعائلية",
  "Luxury & Performance": "الفاخرة والأداء",
  "{{n}} cars available": "{{n}} مركبة متاحة",
  "Price: low to high": "السعر: من الأقل إلى الأعلى",
  "Price: high to low": "السعر: من الأعلى إلى الأقل",
  "Edit search": "تعديل البحث",
  "Delivered in {{place}}": "التوصيل في {{place}}",
  "No cars match this search": "لا توجد سيارات تطابق هذا البحث",
  " in this category": " في هذه الفئة",
  "adjust your dates": "عدّل تواريخك",

  // ---------- VehicleCard ----------
  "Group": "المجموعة",
  "Best value": "أفضل قيمة",
  "Most popular": "الأكثر شيوعاً",
  "Save {{pct}}%": "وفّر {{pct}}%",
  "Model Guaranteed": "الطراز مضمون",
  "km/mo": "كم/شهر",
  "Unlimited km (UAE)": "كيلومترات غير محدودة (الإمارات)",
  "Swap eligible": "قابلة للتبديل",
  "/mo": "/شهر",
  "/day": "/يوم",
  "{{amount}} for {{n}} months · incl. VAT · Pay Now": "{{amount}} لمدة {{n}} أشهر · شامل الضريبة · الدفع الآن",
  "{{amount}} for {{n}} days · incl. VAT · Pay Now": "{{amount}} لمدة {{n}} أيام · شامل الضريبة · الدفع الآن",
  "{{pct}}% off": "خصم {{pct}}%",
  "Free cancellation (24h+) · Zero-deposit option · Min age {{age}}":
    "إلغاء مجاني (24 ساعة+) · خيار بدون تأمين · الحد الأدنى للسن {{age}}",
  "View details": "عرض التفاصيل",
  "Book now": "احجز الآن",

  // ---------- PriceSummary ----------
  "Price Summary": "ملخص السعر",
  "Subtotal": "المجموع الفرعي",
  "Promo {{code}}": "رمز الخصم {{code}}",
  "VAT ({{rate}})": "ضريبة القيمة المضافة ({{rate}})",
  "Total": "الإجمالي",
  "Security deposit waived (NDW active)": "تم إعفاء مبلغ الضمان (إعفاء بدون تأمين فعّال)",
  "Security deposit:": "مبلغ الضمان:",
  "{{cc}} credit card pre-auth or {{dc}} debit card charge.":
    "{{cc}} حجز مسبق على بطاقة الائتمان أو {{dc}} خصم على بطاقة الخصم.",
  "Excess mileage AED {{rate}}/km + VAT": "الكيلومترات الزائدة {{rate}} درهم/كم + الضريبة",
  "No charge yet — you review everything on the next step.":
    "لا رسوم بعد — ستراجع كل شيء في الخطوة التالية.",

  // ---------- Fleet page ----------
  "Explore our entire vehicle fleet": "استكشف أسطول مركباتنا بالكامل",
  "Browse hatchbacks, sedans, crossovers, SUVs, people movers and luxury models by rental group. Check specifications, luggage capacity and key features, then check availability.":
    "تصفّح الهاتشباك والسيدان والكروس أوفر والدفع الرباعي والمركبات العائلية والطُرز الفاخرة حسب مجموعة الإيجار. راجِع المواصفات وسعة الأمتعة والمزايا الأساسية، ثم تحقّق من التوفّر.",
  "Pickup location / branch": "موقع الاستلام / الفرع",
  "All Europcar UAE branches": "جميع فروع يوروبكار في الإمارات",
  "Available models · rates incl. VAT — confirm live rate at booking":
    "الطُرز المتاحة · الأسعار شاملة الضريبة — أكّد السعر المباشر عند الحجز",
  "No vehicles match these filters — try resetting.":
    "لا توجد مركبات تطابق هذه الفلاتر — جرّب إعادة الضبط.",
  "Model or Similar Guarantee": "ضمان الطراز أو ما يماثله",
  "Your booking reserves a vehicle category — you'll receive the displayed model or a comparable vehicle in that group, fully serviced and ready to drive.":
    "يحجز طلبك فئة مركبة — وستحصل على الطراز المعروض أو مركبة مماثلة في المجموعة نفسها، مُجهّزة بالكامل وجاهزة للقيادة.",
  "Young & Modern UAE Fleet": "أسطول حديث ومتجدّد في الإمارات",
  "A regularly refreshed fleet, fully serviced and maintained to high safety standards for confident driving across the Emirates.":
    "أسطول يُجدَّد باستمرار، مُجهّز وصيانته وفق أعلى معايير السلامة لقيادة واثقة في جميع أنحاء الإمارات.",
  "Unlimited Mileage Within UAE": "كيلومترات غير محدودة داخل الإمارات",
  "Daily and weekly rentals include unlimited mileage within the UAE, with 24/7 roadside assistance on 800 364.":
    "تشمل الإيجارات اليومية والأسبوعية كيلومترات غير محدودة داخل الإمارات، مع مساعدة على الطريق على مدار الساعة عبر 800 364.",
  "Make any car yours": "اجعل أي سيارة لك",
  "Zero-excess SCDW from AED 35/day, No-Deposit rental, personal accident insurance, child seats and additional drivers — every extra is one tap at booking, priced upfront with VAT shown.":
    "إعفاء أضرار الاصطدام بدون تحمّل ابتداءً من 35 درهم/يوم، وإيجار بدون تأمين، وتأمين الحوادث الشخصية، ومقاعد الأطفال والسائقون الإضافيون — كل إضافة بنقرة واحدة عند الحجز، بسعر معلن مع إظهار الضريبة.",
  "Check availability & book": "تحقّق من التوفّر واحجز",

  // ---------- FleetCard ----------
  "Gallery ({{n}})": "المعرض ({{n}})",
  "{{n}} Seats": "{{n}} مقاعد",
  "less": "أقل",
  "+{{n}} more": "+{{n}} المزيد",
  "Security hold": "حجز ضمان",
  "(credit)": "(ائتمان)",
  "(debit)": "(خصم)",
  "No-deposit rental available": "متاح إيجار بدون تأمين",
  "Standard": "قياسي",
  "Premium": "بريميوم",
  "Min age {{age}}": "الحد الأدنى للسن {{age}}",
  "Excess AED {{excess}}": "التحمّل {{excess}} درهم",
  "From AED {{amt}}": "ابتداءً من {{amt}} درهم",
  "/ day": "/ يوم",
  "CDW Insurance Included": "تأمين إعفاء الاصطدام مشمول",
  "Weekly AED {{w}} · Monthly AED {{m}} · incl. VAT": "أسبوعي {{w}} درهم · شهري {{m}} درهم · شامل الضريبة",
  "Indicative — confirm live rate at booking": "تقديري — أكّد السعر المباشر عند الحجز",
  "View Details": "عرض التفاصيل",
  "Reserve": "احجز",

  // ---------- FleetFilters ----------
  "Recommended": "موصى به",
  "Price: Low to High": "السعر: من الأقل إلى الأعلى",
  "Price: High to Low": "السعر: من الأعلى إلى الأقل",
  "Featured": "مميّزة",
  "Best Value": "أفضل قيمة",
  "All Fleet {{n}}": "كل الأسطول {{n}}",
  "Group {{g}} {{n}}": "المجموعة {{g}} {{n}}",
  "Search model, feature or ACRISS…": "ابحث بالطراز أو الميزة أو ACRISS…",
  "Type:": "النوع:",
  "All Types": "كل الأنواع",
  "Seats:": "المقاعد:",
  "Any": "أي عدد",
  "4+ Passengers": "4+ ركاب",
  "5+ Passengers": "5+ ركاب",
  "7+ Passengers": "7+ ركاب",
  "Sort:": "ترتيب:",
  "Reset": "إعادة ضبط",

  // ---------- VehicleDetailModal ----------
  "/week": "/أسبوع",
  "/month": "/شهر",
  "On request": "عند الطلب",
  "Indicative rates incl. 5% VAT · monthly includes 3,000 km":
    "أسعار تقديرية شاملة 5% ضريبة · الشهري يشمل 3,000 كم",
  "Shrink": "تصغير",
  "Expand": "تكبير",
  "{{n}} Passengers": "{{n}} راكب",
  "{{lg}} Large + {{sm}} Small": "{{lg}} كبيرة + {{sm}} صغيرة",
  "Vehicle specifications": "مواصفات المركبة",
  "Horsepower": "قوة المحرك",
  "Fuel consumption": "استهلاك الوقود",
  "CO₂ emissions": "انبعاثات CO₂",
  "Boot capacity": "سعة الصندوق",
  "Estimated range": "المدى التقديري",
  "Type": "النوع",
  "Rental group": "مجموعة الإيجار",
  "Group {{g}} — {{desc}}": "المجموعة {{g}} — {{desc}}",
  "Included comfort & safety amenities": "وسائل الراحة والسلامة المشمولة",
  "Best suited for": "الأنسب لـ",
  "Security hold & deposit": "حجز الضمان والتأمين",
  "Credit card hold AED {{cc}} (pre-auth, released 21–28 days after return) or debit-card deposit AED {{dc}}. Excess AED {{excess}} · Minimum driver age {{age}}.":
    "حجز على بطاقة الائتمان {{cc}} درهم (حجز مسبق، يُفرَج عنه خلال 21–28 يوماً بعد الإرجاع) أو تأمين على بطاقة الخصم {{dc}} درهم. التحمّل {{excess}} درهم · الحد الأدنى لسن السائق {{age}}.",
  "Prefer no hold at all? Choose the No-Deposit Waiver at booking — nothing blocked on your card.":
    "تفضّل عدم وجود أي حجز؟ اختر إعفاء بدون تأمين عند الحجز — لن يُحجز أي مبلغ على بطاقتك.",
  "Select this car": "اختر هذه السيارة",
  "Fleet Guide is for reference — confirm live rates at booking, or call 800 EUROPCAR (800 38767227)":
    "دليل الأسطول للاستدلال فقط — أكّد الأسعار المباشرة عند الحجز، أو اتصل بـ 800 EUROPCAR (800 38767227)",

  // ---------- Booking (review) page ----------
  "Zero excess on own-damage claims — drive with total peace of mind.": "بدون تحمّل على مطالبات أضرار سيارتك — قُد براحة بال تامة.",
  "Personal accident cover for you and every passenger.": "تغطية الحوادث الشخصية لك ولكل راكب.",
  "Safety-certified seats for every age — required by UAE law under 4.": "مقاعد معتمدة للسلامة لكل الأعمار — إلزامية بقانون الإمارات لمن هم دون 4 سنوات.",
  "Share the driving on long trips — registered and insured properly.": "شارِك القيادة في الرحلات الطويلة — مُسجَّل ومؤمَّن حسب الأصول.",
  "Please wait for your price to update": "يرجى الانتظار حتى يتم تحديث السعر",
  "locked in for you": "محجوزة لك",
  "({{n}} months)": "({{n}} أشهر)",
  "Make it yours": "اجعلها لك",
  "Every rental already includes CDW and AED 3.65M third-party cover. These extras take the last bit of worry off the road — most drivers add at least one.":
    "كل إيجار يشمل بالفعل إعفاء أضرار الاصطدام وتغطية طرف ثالث بقيمة 3.65 مليون درهم. هذه الإضافات تزيح آخر ما يقلقك على الطريق — ومعظم السائقين يضيفون واحدة على الأقل.",
  "Recommended · Most added": "موصى به · الأكثر إضافة",
  "Rent with No Deposit or Security blocking — {{fee}}": "استأجر بدون تأمين أو حجز مبلغ ضمان — {{fee}}",
  "AED 410/mo": "410 درهم/شهر",
  "AED 50/day · 260/wk": "50 درهم/يوم · 260/أسبوع",
  "AED 210/mo": "210 درهم/شهر",
  "AED 35/day · 160/wk": "35 درهم/يوم · 160/أسبوع",
  "Skip the {{amount}} credit-card pre-authorization entirely. Your card limit stays yours.":
    "تجاوز الحجز المسبق على بطاقة الائتمان بقيمة {{amount}} تماماً. يبقى حد بطاقتك متاحاً لك.",
  "Payment preference": "تفضيل الدفع",
  "Pay Now": "الدفع الآن",
  "Best online price — as displayed": "أفضل سعر عبر الإنترنت — كما هو معروض",
  "Pay Later at counter": "الدفع لاحقاً عند المكتب",
  "Adds 5% to your total": "يضيف 5% إلى إجماليك",
  "Promo code": "رمز الخصم",
  "Apply": "تطبيق",
  "Before you pay — the essentials": "قبل الدفع — الأساسيات",
  "Minimum age 21 (25 for premium vehicles) · valid license required · \"or similar\" model policy.":
    "الحد الأدنى للسن 21 (25 للمركبات الفاخرة) · رخصة سارية مطلوبة · سياسة الطراز \"أو ما يماثله\".",
  "Daily & weekly: unlimited km within UAE · Monthly: from 3,000 km included · excess mileage AED {{rate}}/km + VAT.":
    "يومي وأسبوعي: كيلومترات غير محدودة داخل الإمارات · شهري: من 3,000 كم مشمولة · الكيلومترات الزائدة {{rate}} درهم/كم + الضريبة.",
  "Fuel: return at the same level. Tolls (Salik in Dubai, Darb in Abu Dhabi) are billed after your rental + 25% admin fee; fines + 10% admin fee + VAT.":
    "الوقود: أعِد المركبة بالمستوى نفسه. الرسوم المرورية (سالك في دبي، درب في أبوظبي) تُحتسَب بعد الإيجار + رسم إداري 25%؛ المخالفات + رسم إداري 10% + الضريبة.",
  "No deposit — waived by your No-Deposit Waiver.": "بدون تأمين — مُعفى بموجب إعفاء بدون تأمين.",
  "Security deposit at handover: {{cc}} credit-card pre-auth or {{dc}} debit-card charge (refunded within 21 working days).":
    "مبلغ ضمان عند التسليم: {{cc}} حجز مسبق على بطاقة الائتمان أو {{dc}} خصم على بطاقة الخصم (يُسترَد خلال 21 يوم عمل).",
  "Delivery address details are taken at checkout, on the next step.": "تُؤخذ تفاصيل عنوان التوصيل عند الدفع في الخطوة التالية.",
  "Documents you'll upload after booking (2 minutes):": "المستندات التي سترفعها بعد الحجز (دقيقتان):",
  " Emirates ID or passport, plus your driving license. Camera or file upload, JPEG/PNG/PDF up to 5 MB — we need them to verify the driver before handover.":
    " الهوية الإماراتية أو جواز السفر، بالإضافة إلى رخصة القيادة. تصوير أو رفع ملف، JPEG/PNG/PDF حتى 5 ميغابايت — نحتاجها للتحقق من السائق قبل التسليم.",
  "Free cancellation": "إلغاء مجاني",
  " until 24 hours before pickup — full refund, no questions.": " حتى 24 ساعة قبل الاستلام — استرداد كامل بلا أسئلة.",
  "24/7 roadside": "مساعدة على الطريق 24/7",
  " on 800 364, anywhere in the UAE — included on every rental.": " عبر 800 364، في أي مكان بالإمارات — مشمولة في كل إيجار.",
  "Humans on call": "فريق بشري متاح",
  " — 800-EUROPCAR, before, during and after your rental.": " — 800-EUROPCAR، قبل إيجارك وأثناءه وبعده.",
  "Continue to payment": "المتابعة إلى الدفع",
  "Total incl. VAT": "الإجمالي شامل الضريبة",
  "Continue": "متابعة",

  // ---------- Payment page ----------
  "Please complete the driver details": "يرجى إكمال بيانات السائق",
  "Let's fix this — that email doesn't look complete": "لنُصلح ذلك — يبدو أنّ البريد الإلكتروني غير مكتمل",
  "Please enter your delivery address": "يرجى إدخال عنوان التوصيل",
  "Please confirm the required declarations to continue": "يرجى تأكيد الإقرارات المطلوبة للمتابعة",
  "Please enter valid card details (demo — any numbers work)": "يرجى إدخال بيانات بطاقة صحيحة (تجريبي — أي أرقام تعمل)",
  "Booking confirmed!": "تم تأكيد الحجز!",
  "Demo payment mode": "وضع الدفع التجريبي",
  " — no real charge will be made. Gateway integration arrives in V2.": " — لن يتم أي خصم فعلي. سيصل تكامل بوابة الدفع في الإصدار الثاني.",
  "Main driver details": "بيانات السائق الرئيسي",
  "Full name (as on license) *": "الاسم الكامل (كما في الرخصة) *",
  "Email *": "البريد الإلكتروني *",
  "Phone *": "الهاتف *",
  "Driving license no. (optional)": "رقم رخصة القيادة (اختياري)",
  "Delivery address": "عنوان التوصيل",
  "Building, street & area in {{place}} *": "المبنى والشارع والمنطقة في {{place}} *",
  "e.g. Marina Tower 3, Al Marsa Street, Dubai Marina": "مثال: مارينا تاور 3، شارع المرسى، مرسى دبي",
  "Card payment (simulated)": "الدفع بالبطاقة (محاكاة)",
  "Card number *": "رقم البطاقة *",
  "Expiry *": "تاريخ الانتهاء *",
  "CVV *": "رمز التحقق CVV *",
  "Cardholder name": "اسم حامل البطاقة",
  "3-D Secure simulation · PCI-DSS placeholder · pre-auth fields wired for future gateway":
    "محاكاة 3-D Secure · عنصر نائب PCI-DSS · حقول الحجز المسبق مهيّأة لبوابة مستقبلية",
  "Pay at counter": "الدفع عند المكتب",
  "You've chosen Pay Later. Your card will be requested at handover. Total includes the 5% pay-later premium.":
    "اخترت الدفع لاحقاً. ستُطلب بطاقتك عند التسليم. يشمل الإجمالي علاوة الدفع لاحقاً بنسبة 5%.",
  "Your declarations": "إقراراتك",
  " (25, as a premium vehicle is selected)": " (25، لأنّه تم اختيار مركبة فاخرة)",
  "I am 21 years of age{{premium}} and legally allowed to drive in the UAE. I understand I must present a physical copy of my ID/Passport and Driver's License as per UAE regulations.":
    "عمري 21 عاماً{{premium}} ومسموح لي قانوناً بالقيادة في الإمارات. وأدرك أنّه عليّ تقديم نسخة أصلية من هويتي/جواز سفري ورخصة القيادة وفق أنظمة الإمارات.",
  "I have reviewed the terms and conditions and agree to them.": "لقد راجعت الشروط والأحكام وأوافق عليها.",
  "I understand the credit-card pre-authorization or debit-card deposit is processed at vehicle handover and I will have the physical card with me (Apple Pay / Google Pay cannot be accepted per regulations).":
    "أدرك أنّ الحجز المسبق على بطاقة الائتمان أو مبلغ الضمان على بطاقة الخصم يُعالَج عند تسليم المركبة، وأنّه ستكون بحوزتي البطاقة الفعلية (لا يمكن قبول Apple Pay / Google Pay وفق الأنظمة).",
  "Pay {{amount}} & confirm": "ادفع {{amount}} وأكّد",
  "Confirm booking — pay at counter": "أكّد الحجز — ادفع عند المكتب",
  "Free cancellation until 24h before pickup": "إلغاء مجاني حتى 24 ساعة قبل الاستلام",
  "CDW + AED 3.65M cover included": "إعفاء أضرار الاصطدام + تغطية 3.65 مليون درهم مشمولة",
  "800-EUROPCAR — 24/7 human support": "800-EUROPCAR — دعم بشري على مدار الساعة",

  // ---------- Confirmation page ----------
  "Booking not found.": "لم يُعثر على الحجز.",
  "Go to My Bookings": "الذهاب إلى حجوزاتي",
  "Booking confirmed": "تم تأكيد الحجز",
  "A confirmation email has been sent to {{email}} (demo mode)": "تم إرسال بريد تأكيد إلى {{email}} (الوضع التجريبي)",
  "Booking reference": "رقم مرجع الحجز",
  "Monthly · {{n}} mo · {{km}} km/mo": "شهري · {{n}} شهر · {{km}} كم/شهر",
  "Short-term rental": "إيجار قصير الأمد",
  "until": "حتى",
  "Doorstep delivery": "توصيل إلى الباب",
  "Branch pickup": "الاستلام من الفرع",
  "{{address}} · {{time}} slot": "{{address}} · موعد {{time}}",
  " · Flight {{n}} tracked": " · جارٍ تتبّع الرحلة {{n}}",
  "Payment:": "الدفع:",
  "Paid (demo) — {{amount}}": "مدفوع (تجريبي) — {{amount}}",
  "Pay at counter — {{amount}}": "الدفع عند المكتب — {{amount}}",
  " · Ref {{id}}": " · مرجع {{id}}",
  "Complete your file — 2 minutes": "أكمل ملفك — دقيقتان",
  "Upload your Emirates ID or passport plus your driving license so we can verify the driver before handover — it keeps your pickup or delivery quick and paper-free. Camera or file upload, JPEG/PNG/PDF up to 5 MB.":
    "ارفع هويتك الإماراتية أو جواز سفرك بالإضافة إلى رخصة القيادة لنتحقّق من السائق قبل التسليم — لإبقاء استلامك أو توصيلك سريعاً وبلا أوراق. تصوير أو رفع ملف، JPEG/PNG/PDF حتى 5 ميغابايت.",
  "Upload documents now": "ارفع المستندات الآن",
  "Check in online": "تسجيل الوصول عبر الإنترنت",
  "Download invoice (PDF)": "تحميل الفاتورة (PDF)",
  "Manage in My Bookings": "الإدارة في حجوزاتي",
  "Book another car": "احجز سيارة أخرى",

  // ---------- Monthly page ----------
  "Starting from AED {{amt}}/month incl. VAT": "ابتداءً من {{amt}} درهم/شهر شامل الضريبة",
  "Best rates for 22+ days": "أفضل الأسعار لـ 22+ يوماً",
  "Around 35% less per day than daily rates — with maintenance, registration, insurance and 24/7 roadside all included.":
    "أقل بنحو 35% في اليوم مقارنة بالأسعار اليومية — مع شمول الصيانة والتسجيل والتأمين والمساعدة على الطريق على مدار الساعة.",
  "Minimum first booking is 22 days — a rental of 22–30 days counts as 1 rental month. For shorter trips, our Daily & Weekly engine has you covered.":
    "الحد الأدنى لأول حجز هو 22 يوماً — ويُحتسَب الإيجار من 22 إلى 30 يوماً كشهر إيجار واحد. وللرحلات الأقصر، محرّك اليومي والأسبوعي لدينا يغطّيك.",
  "Term": "المدة",
  "{{n}} mo": "{{n}} شهر",
  "Popular": "شائع",
  "Model year": "سنة الطراز",
  "Mileage / month": "الكيلومترات / الشهر",
  "{{n}} km": "{{n}} كم",
  "(required before booking — rates visible either way)": "(مطلوب قبل الحجز — الأسعار ظاهرة في الحالتين)",
  "No cars available for this configuration — try a different term, mileage or start date.":
    "لا توجد سيارات متاحة لهذا الإعداد — جرّب مدة أو كيلومترات أو تاريخ بدء مختلف.",
  "What's included": "ما هو مشمول",
  "Maintenance & servicing": "الصيانة والخدمة الدورية",
  "Registration & insurance (CDW)": "التسجيل والتأمين (إعفاء أضرار الاصطدام)",
  "AED 3.65M third-party cover": "تغطية طرف ثالث بقيمة 3.65 مليون درهم",
  "Free replacement on breakdown": "استبدال مجاني عند الأعطال",
  "Renew or extend from your account": "التجديد أو التمديد من حسابك",
  "Not included": "غير مشمول",
  "Fuel": "الوقود",
  "Tolls — Salik/Darb (billed + 25% admin fee)": "الرسوم — سالك/درب (تُحتسَب + رسم إداري 25%)",
  "Traffic fines (+10% admin fee + VAT)": "المخالفات المرورية (+ رسم إداري 10% + الضريبة)",
  "Excess mileage (AED 0.50–0.75/km + VAT)": "الكيلومترات الزائدة (0.50–0.75 درهم/كم + الضريبة)",
  "Ending early?": "تريد الإنهاء مبكراً؟",
  " In plain words: finish any started rental month, give us 7 days notice, and we recalculate your rate at the term you actually kept — no hidden penalties.":
    " ببساطة: أكمِل أي شهر إيجار بدأته، وأشعِرنا قبل 7 أيام، ونعيد احتساب سعرك وفق المدة التي احتفظت بها فعلياً — دون غرامات خفية.",

  // ---------- Promise page ----------
  "The Europcar promise": "وعد يوروبكار",
  "Three commitments, kept on every rental. Written plainly, because that's the point.":
    "ثلاثة التزامات نفي بها في كل إيجار. مكتوبة بوضوح، لأنّ هذا هو المقصد.",
  "Transparent pricing": "تسعير شفّاف",
  "The price you see is the price you pay — Pay Now, VAT included, deposit disclosed before checkout. No airport surprises, no fine-print fees, no 'from' prices that double at the counter.":
    "السعر الذي تراه هو ما تدفعه — الدفع الآن، شامل الضريبة، والتأمين معلن قبل الدفع. لا مفاجآت في المطار، ولا رسوم مخفية، ولا أسعار \"ابتداءً من\" تتضاعف عند المكتب.",
  "Every charge itemized before payment": "كل رسم مفصّل قبل الدفع",
  "Deposit or No-Deposit Waiver — your choice": "تأمين أو إعفاء بدون تأمين — الخيار لك",
  "Toll and fine admin fees published upfront": "رسوم إدارة الطرق والمخالفات معلنة مسبقاً",
  "Ready when we say": "جاهزة في موعدها",
  "Three hours after booking, your car is at the branch. Book delivery and we arrive inside your chosen 30-minute slot. Land late? We track your flight and wait — at no extra charge.":
    "بعد ثلاث ساعات من الحجز، تكون سيارتك في الفرع. احجز التوصيل ونصل ضمن الموعد الذي اخترته (30 دقيقة). تأخّر هبوطك؟ نتتبّع رحلتك وننتظر — دون رسوم إضافية.",
  "3-hour branch readiness, guaranteed": "جاهزية بالفرع خلال 3 ساعات، مضمونة",
  "30-minute delivery slots, 09:00–21:00": "مواعيد توصيل من 30 دقيقة، 09:00–21:00",
  "Flight tracking on every airport pickup": "تتبّع الرحلات في كل استلام من المطار",
  "People who answer": "فريق يردّ عليك",
  "A breakdown at 3am gets a human, not a phone tree. Complaints get a named response within 2 business days. And if something's our fault, we say so — then fix it.":
    "العطل في الثالثة فجراً يقابله شخص حقيقي، لا قائمة هاتفية. والشكاوى تحصل على ردّ باسم مسؤول خلال يومَي عمل. وإن كان الخطأ منّا، نعترف به — ثم نصلحه.",
  "24/7 roadside assistance, UAE-wide": "مساعدة على الطريق 24/7 في كل الإمارات",
  "2-business-day complaint response": "ردّ على الشكوى خلال يومَي عمل",
  "Replacement vehicle after accident validation": "مركبة بديلة بعد التحقق من الحادث",
  "Hold us to it — book a car": "حاسِبنا على وعدنا — احجز سيارة",

  // ---------- Offers page ----------
  "{{code}} copied — paste it at booking review": "تم نسخ {{code}} — الصقه عند مراجعة الحجز",
  "Offers & promotions": "العروض والترويجات",
  "Genuine discounts, plainly stated. Apply any code on the booking review step — it discounts before VAT.":
    "خصومات حقيقية بوضوح تام. طبّق أي رمز في خطوة مراجعة الحجز — يُحتسَب الخصم قبل الضريبة.",
  "10% off any rental": "خصم 10% على أي إيجار",
  "Applies to daily, weekly and monthly bookings — stack it with your Pay Now price.":
    "ينطبق على الحجوزات اليومية والأسبوعية والشهرية — واجمعه مع سعر الدفع الآن.",
  "AED 50 off your first booking": "خصم 50 درهم على حجزك الأول",
  "A welcome from us to you. Valid on any rental over AED 200.": "ترحيب منّا لك. ساري على أي إيجار يزيد عن 200 درهم.",
  "15% summer special": "عرض الصيف 15%",
  "Beat the heat with our strongest seasonal discount across the full fleet.":
    "اهزم الحر بأقوى خصم موسمي لدينا على الأسطول بالكامل.",
  "New customers": "العملاء الجدد",
  "Limited season": "موسم محدود",
  "Live rate calendar": "تقويم الأسعار المباشر",
  "Rates move with demand — green days are your cheapest start dates.":
    "تتغيّر الأسعار حسب الطلب — الأيام الخضراء هي أرخص تواريخ البدء.",
  "Book with your code": "احجز برمزك",
  "Prices = cheapest vehicle per day": "الأسعار = أرخص مركبة في اليوم",

  // ---------- Network page ----------
  "airport desks, open 24/7": "مكاتب في المطارات، مفتوحة 24/7",
  "doorstep delivery, daily": "توصيل إلى الباب، يومياً",
  "one number, any hour": "رقم واحد، في أي ساعة",
  "Our network & branches": "شبكتنا وفروعنا",
  "From the arrivals hall at DXB to the corniche in Fujairah — wherever you land, we're already there.":
    "من صالة الوصول في مطار دبي إلى كورنيش الفجيرة — أينما تحطّ رحالك، نحن هناك بالفعل.",
  "Open 24 hours": "مفتوح 24 ساعة",
  "Flight tracking available": "تتبّع الرحلات متاح",

  // ---------- About page ----------
  "About Europcar Dubai & Northern Emirates": "عن يوروبكار دبي والإمارات الشمالية",
  "Part of the Europcar Mobility Group's 140-country network, operated locally with a simple brief: make renting a car in the Emirates feel effortless.":
    "جزء من شبكة مجموعة يوروبكار للتنقّل في 140 دولة، وتُدار محلياً بمهمة بسيطة: أن يكون استئجار السيارة في الإمارات سهلاً بلا عناء.",
  "Who we are": "من نحن",
  "We run 9 branches across Dubai, Sharjah, Ras Al Khaimah and Fujairah, a delivery operation covering all six emirates, and a fleet of 53 vehicles from city hatchbacks to the Land Cruiser. Our customers are residents on monthly plans, tourists off a red-eye at Terminal 3, and businesses that need twenty cars by Thursday.":
    "ندير 9 فروع في دبي والشارقة ورأس الخيمة والفجيرة، وعملية توصيل تغطي الإمارات الست جميعها، وأسطولاً من 53 مركبة من هاتشباك المدينة إلى لاند كروزر. عملاؤنا مقيمون على خطط شهرية، وسياح يصلون بالرحلات الليلية إلى المبنى 3، وشركات تحتاج عشرين سيارة بحلول الخميس.",
  "Everything on this site — pricing, deposits, tolls, fines — is written the way we'd want it explained to us. That's the whole philosophy.":
    "كل ما في هذا الموقع — الأسعار والودائع والرسوم والمخالفات — مكتوب بالطريقة التي نودّ أن يُشرَح لنا بها. هذه هي الفلسفة كلها.",
  "Europcar Mobility Group": "مجموعة يوروبكار للتنقّل",
  "Founded in Paris in 1949, Europcar Mobility Group is a global leader in mobility services with brands including Europcar, Goldcar and Fox Rent-a-Car — present in over 140 countries with a fleet exceeding 350,000 vehicles. The Dubai & Northern Emirates franchise brings that network's standards to the UAE.":
    "تأسّست في باريس عام 1949، ومجموعة يوروبكار للتنقّل رائدة عالمياً في خدمات التنقّل بعلامات تشمل يوروبكار وغولدكار وفوكس رينت-أ-كار — حاضرة في أكثر من 140 دولة بأسطول يتجاوز 350,000 مركبة. وتجلب امتيازات دبي والإمارات الشمالية معايير تلك الشبكة إلى الإمارات.",
  "Visit the EGMG website →": "زُر موقع EGMG ←",
  "Careers": "الوظائف",
  "We hire for branches, delivery and customer care across the emirates. Applications are handled on the EGMG careers portal —":
    "نوظّف للفروع والتوصيل وخدمة العملاء في جميع أنحاء الإمارات. وتُدار الطلبات عبر بوابة وظائف EGMG —",
  "view open positions": "عرض الوظائف الشاغرة",
  "Europcar Cares": "يوروبكار تهتم",
  "Youngest fleet, lowest footprint": "أحدث أسطول، أقل بصمة",
  "A 2025–2026 fleet means modern engines, hybrids and EVs — cutting average fleet emissions year on year.":
    "أسطول 2025–2026 يعني محركات حديثة وسيارات هجينة وكهربائية — ما يخفّض متوسط انبعاثات الأسطول عاماً بعد عام.",
  "Road safety with the RTA": "السلامة المرورية مع هيئة الطرق",
  "We fund child-seat awareness campaigns and provide RTA-compliant seats on every booking that needs one.":
    "نموّل حملات التوعية بمقاعد الأطفال ونوفّر مقاعد مطابقة لهيئة الطرق في كل حجز يحتاجها.",
  "Community mobility": "تنقّل المجتمع",
  "Discounted monthly rentals for verified frontline healthcare workers across the Northern Emirates.":
    "إيجارات شهرية مخفّضة للعاملين في الخطوط الأمامية بالرعاية الصحية المُوثّقين في الإمارات الشمالية.",
  "Sitemap": "خريطة الموقع",
  "Monthly Rentals": "الإيجارات الشهرية",
  "Our Network": "شبكتنا",
  "The Promise": "الوعد",
  "Report an Accident": "الإبلاغ عن حادث",

  // ---------- Help page ----------
  "Help & support": "المساعدة والدعم",
  "{{n}} answers, written by the people who run the counters.": "{{n}} إجابة، كتبها من يديرون المكاتب.",
  "Search deposits, delivery, fines, documents…": "ابحث في الودائع والتوصيل والمخالفات والمستندات…",
  "Nothing matched \"{{query}}\" — try a different word, or chat with us in the corner.":
    "لا شيء يطابق \"{{query}}\" — جرّب كلمة مختلفة، أو تحدّث معنا في الزاوية.",
  " (800 38767227) — 24/7, humans included.": " (800 38767227) — 24/7، بفريق بشري.",
  "Or chat with us in the bottom-right corner.": "أو تحدّث معنا في الزاوية السفلية اليمنى.",
  "Accidents & Roadside": "الحوادث والمساعدة على الطريق",
  "Account & Billing": "الحساب والفوترة",
  "Booking & Payments": "الحجز والمدفوعات",
  "Delivery & Pickup": "التوصيل والاستلام",
  "Documents & Eligibility": "المستندات والأهلية",
  "Fines & Tolls": "المخالفات والرسوم",
  "Insurance & Deposits": "التأمين والودائع",

  // ---------- Locations page ----------
  "Wherever you land, we're close.": "أينما تحطّ رحالك، نحن قريبون.",
  "9 branches across Dubai, Sharjah, Ras Al Khaimah and Fujairah — airport desks open around the clock, plus doorstep delivery across all six emirates.":
    "9 فروع في دبي والشارقة ورأس الخيمة والفجيرة — مكاتب المطارات مفتوحة على مدار الساعة، مع توصيل إلى الباب في الإمارات الست جميعها.",
  "Open 24/7": "مفتوح 24/7",
  "Daily {{base}}": "يومياً {{base}}",
  "Mon–Sat {{base}} · Sun closed": "الإثنين–السبت {{base}} · الأحد مغلق",
  "Airport": "مطار",
  "Pickup: {{d}}": "الاستلام: {{d}}",
  "Reserve here": "احجز هنا",
  "Map": "خريطة",
  "Prefer not to travel? We deliver to your door across all six emirates, daily 09:00–21:00 — in as little as 4 hours in Dubai & Sharjah.":
    "تفضّل عدم التنقّل؟ نوصّل إلى بابك في الإمارات الست جميعها، يومياً من 09:00 إلى 21:00 — خلال 4 ساعات فقط في دبي والشارقة.",
  "Book a delivery": "احجز توصيلاً",
  "Note: Abu Dhabi & Al Ain are served by Europcar Abu Dhabi.": "ملاحظة: أبوظبي والعين تخدمهما يوروبكار أبوظبي.",
  "Arrivals Hall, Terminal 1 — look for the green Europcar desk, 24/7": "صالة الوصول، المبنى 1 — ابحث عن مكتب يوروبكار الأخضر، 24/7",
  "Arrivals Hall, Terminal 3, beside the hotel desks — 24/7 counter": "صالة الوصول، المبنى 3، بجوار مكاتب الفنادق — مكتب 24/7",
  "6th Street, Al Quoz Industrial Area 1 — near the Porsche showroom, Sheikh Zayed Road Exit 41": "الشارع السادس، القوز الصناعية 1 — قرب معرض بورشه، مخرج 41 على شارع الشيخ زايد",
  "Dubai Hills Mall — Ground Floor / P1 parking level, Al Khail Road entrance": "دبي هيلز مول — الطابق الأرضي / مستوى مواقف P1، مدخل شارع الخيل",
  "Jumeirah Emirates Towers — hotel entrance, Trade Centre Second": "أبراج الإمارات جميرا — مدخل الفندق، مركز التجارة الثاني",
  "Car Rental Center, Arrivals Hall — 24/7 desk": "مركز تأجير السيارات، صالة الوصول — مكتب 24/7",
  "Abu Al Reesh Building (ground floor), Al Zahra Street, near King Faisal Mosque": "مبنى أبو الريش (الطابق الأرضي)، شارع الزهراء، قرب مسجد الملك فيصل",
  "Al Hamra Mall, Ground Floor — Al Hamra Village, Sheikh Mohamed Bin Salem Road": "الحمرا مول، الطابق الأرضي — قرية الحمرا، شارع الشيخ محمد بن سالم",
  "Al Awadhi Office Towers (FEWA Office Building), Hamad Bin Abdulla Road": "أبراج العوضي المكتبية (مبنى مكاتب هيئة كهرباء ومياه الاتحاد)، شارع حمد بن عبدالله",

  // ---------- RentACar page ----------
  "Rent a car — your way": "استأجر سيارة — على طريقتك",
  "Two products, one promise: transparent Pay Now pricing incl. VAT, maintenance included, and no hidden charges.":
    "منتجان ووعد واحد: تسعير شفّاف بالدفع الآن شامل الضريبة، والصيانة مشمولة، وبلا رسوم خفية.",
  "Minimum term": "الحد الأدنى للمدة",
  "1 day": "يوم واحد",
  "22 days (counts as 1 month)": "22 يوماً (تُحتسَب كشهر واحد)",
  "Deposit": "التأمين",
  "Hold AED 1,500–2,500 (credit) or AED 2,000–3,000 (debit) — or No-Deposit": "حجز 1,500–2,500 درهم (ائتمان) أو 2,000–3,000 درهم (خصم) — أو بدون تأمين",
  "Same — or No-Deposit option": "المثل — أو خيار بدون تأمين",
  "Mileage": "الكيلومترات",
  "3,000 km/mo · 4,000/5,000 km upgrades": "3,000 كم/شهر · ترقيات 4,000/5,000 كم",
  "Insurance included": "التأمين مشمول",
  "Comprehensive + CDW + AED 3.65M third-party": "شامل + إعفاء أضرار الاصطدام + طرف ثالث 3.65 مليون درهم",
  "Maintenance": "الصيانة",
  "Included": "مشمولة",
  "Delivery": "التوصيل",
  "AED 100–200 + VAT per trip, 09:00–21:00": "100–200 درهم + الضريبة لكل رحلة، 09:00–21:00",
  "Free in Dubai & Sharjah · AED 100–200 elsewhere": "مجاني في دبي والشارقة · 100–200 درهم في غيرها",
  "Ideal for": "مثالي لـ",
  "Tourists, weekends, business trips": "السياح وعطلات نهاية الأسبوع ورحلات العمل",
  "Residents, projects, long stays": "المقيمين والمشاريع والإقامات الطويلة",
  "Select Daily / Weekly": "اختر يومي / أسبوعي",
  "Select Monthly": "اختر شهري",
  "What's included — and what isn't": "ما هو مشمول — وما هو غير مشمول",
  "Rental policies": "سياسات الإيجار",
  "Approved customer information for vehicles rented from Europcar. Rates, availability and branch details are confirmed at time of booking.":
    "معلومات معتمدة للعملاء عن المركبات المستأجرة من يوروبكار. تُؤكَّد الأسعار والتوفّر وتفاصيل الفروع عند الحجز.",
  "Rental Duration & Pricing": "مدة الإيجار والتسعير",
  "What's Included": "ما هو مشمول",
  "Eligibility & Documents": "الأهلية والمستندات",
  "Delivery & Collection": "التوصيل والاستلام",
  "Grace Period & Late Return": "فترة السماح والإرجاع المتأخّر",
  "Security Hold (Credit Card)": "حجز الضمان (بطاقة الائتمان)",
  "Debit-Card Deposit": "تأمين بطاقة الخصم",
  "No-Deposit Rental": "إيجار بدون تأمين",
  "Insurance, Excess & SCDW": "التأمين والتحمّل وإعفاء الاصطدام الفائق",
  "Fuel, Tolls & Fines": "الوقود والرسوم والمخالفات",
  "Add-Ons": "الإضافات",
  "Cancellations & No-Shows": "الإلغاء وعدم الحضور",
  "Frequently asked": "الأسئلة الشائعة",
  "What's the difference between Daily/Weekly and Monthly rentals?": "ما الفرق بين الإيجار اليومي/الأسبوعي والشهري؟",
  "Daily and weekly cover 1–21 days with total flexibility; from 22 days our monthly engine gives you a lower rate, terms of 1/3/6/9 months, and 3,000 or 5,000 km per month — maintenance included on both.":
    "يغطي اليومي والأسبوعي 1–21 يوماً بمرونة كاملة؛ ومن 22 يوماً يمنحك محرّكنا الشهري سعراً أقل، ومدداً من 1/3/6/9 أشهر، و3,000 أو 5,000 كم شهرياً — والصيانة مشمولة في الحالتين.",
  "Which is cheaper for a 3-week trip?": "أيهما أرخص لرحلة مدتها 3 أسابيع؟",
  "At 7–21 days you pay the weekly band rate pro-rated per day — already better value than daily. At 22+ days one flat monthly rate usually wins — our engine automatically suggests the switch when your dates qualify.":
    "من 7 إلى 21 يوماً تدفع سعر الشريحة الأسبوعية موزّعاً على الأيام — وهو أفضل قيمة من اليومي. ومن 22 يوماً فأكثر يفوز عادةً السعر الشهري الثابت — ويقترح محرّكنا التبديل تلقائياً عندما تتأهّل تواريخك.",
  "Can I switch from daily to monthly mid-rental?": "هل يمكنني التبديل من اليومي إلى الشهري أثناء الإيجار؟",
  "Yes — raise a service request from your Account and we convert your rental at the monthly rate from your next billing cycle.":
    "نعم — أرسِل طلب خدمة من حسابك ونحوّل إيجارك إلى السعر الشهري من دورة الفوترة التالية.",
  "Do both include airport pickup and delivery?": "هل يشمل كلاهما الاستلام من المطار والتوصيل؟",
  "Yes. Collect at Dubai T1, T3, Sharjah Airport or any branch — or have the car delivered to your door between 09:00 and 21:00.":
    "نعم. استلِم من مطار دبي المبنى 1 أو 3 أو مطار الشارقة أو أي فرع — أو اطلب توصيل السيارة إلى بابك بين 09:00 و21:00.",
  "Rent with No Deposit or Security blocking — available for a nominal fee based on vehicle group and tenure.":
    "استأجر بدون تأمين أو حجز مبلغ ضمان — متاح مقابل رسم رمزي حسب فئة المركبة ومدة الإيجار.",
  "Start a booking": "ابدأ حجزاً",

  // ---------- International page ----------
  "International rentals": "الإيجارات الدولية",
  "Europcar operates in 140+ countries. Tell us where you're headed — our international desk arranges your booking through the global network, honestly tracked at every step.":
    "تعمل يوروبكار في أكثر من 140 دولة. أخبِرنا بوجهتك — وينظّم مكتبنا الدولي حجزك عبر الشبكة العالمية، مع تتبّع صادق في كل خطوة.",
  "Request {{id}} received": "تم استلام الطلب {{id}}",
  "We're honest about timing: our international desk responds within 1 business day with availability and a firm quote for {{dest}}. Nothing is charged until you approve it.":
    "نحن صادقون بشأن التوقيت: يردّ مكتبنا الدولي خلال يوم عمل واحد بالتوفّر وعرض سعر نهائي لـ {{dest}}. ولا يُخصَم شيء حتى توافق عليه.",
  "Destination *": "الوجهة *",
  "Start typing a city…": "ابدأ بكتابة اسم مدينة…",
  "Pickup date *": "تاريخ الاستلام *",
  "Rental length (days) *": "مدة الإيجار (أيام) *",
  "Full name *": "الاسم الكامل *",
  "Request my international quote": "اطلب عرض سعري الدولي",
  "Sending…": "جارٍ الإرسال…",
  "How it works": "كيف تعمل",
  "Request received": "تم استلام الطلب",
  "International desk review": "مراجعة المكتب الدولي",
  "Partner confirmation": "تأكيد الشريك",
  "Voucher issued to your email": "إصدار القسيمة إلى بريدك",
  "Typical turnaround: 1 business day. International bookings are fulfilled by Europcar partners in the destination country.":
    "المدة المعتادة: يوم عمل واحد. تُنفَّذ الحجوزات الدولية عبر شركاء يوروبكار في بلد الوجهة.",

  // ---------- Contact page ----------
  "We're here to help.": "نحن هنا لمساعدتك.",
  "Questions about a booking, a charge or anything on four wheels — reach us however suits you best.":
    "أسئلة عن حجز أو رسم أو أي شيء يخص السيارات — تواصل معنا بالطريقة التي تناسبك.",
  "Call us": "اتصل بنا",
  "Reservations: 800-EUROPCAR / 800463": "الحجوزات: 800-EUROPCAR / 800463",
  "Roadside 24/7: 800 364": "المساعدة على الطريق 24/7: 800 364",
  "WhatsApp": "واتساب",
  "Message us on 800463": "راسِلنا على 800463",
  "Replies within business hours": "الردود خلال ساعات العمل",
  "Email": "البريد الإلكتروني",
  "Prefer face to face? Find your nearest of 9 branches.": "تفضّل اللقاء المباشر؟ اعثر على أقرب فرع من فروعنا التسعة.",
  "Branch locator": "دليل الفروع",
  "Send us a message": "أرسل لنا رسالة",
  "Message received — ref {{id}}": "تم استلام الرسالة — مرجع {{id}}",
  "Our customer care team replies within one business day. A confirmation email is on its way (demo mode — logged, not sent).":
    "يردّ فريق خدمة العملاء خلال يوم عمل واحد. وبريد التأكيد في طريقه إليك (الوضع التجريبي — يُسجَّل ولا يُرسَل).",
  "Phone": "الهاتف",
  "Topic": "الموضوع",
  "Message *": "الرسالة *",
  "Send message": "إرسال الرسالة",
  "Booking enquiry": "استفسار عن حجز",
  "Existing rental": "إيجار قائم",
  "Billing or invoice": "الفوترة أو الفاتورة",
  "Feedback": "ملاحظات",
  "Something else": "شيء آخر",

  // ---------- SearchPage ----------
  "Find it fast.": "اعثر عليه بسرعة.",
  "Try 'Tucson', 'deposit', 'delivery'…": "جرّب \"توسان\" أو \"تأمين\" أو \"توصيل\"…",
  "Search": "بحث",
  "{{n}} results for \"{{q}}\"": "{{n}} نتيجة لـ \"{{q}}\"",
  "Vehicles": "المركبات",
  "Articles": "المقالات",
  "Support answers": "إجابات الدعم",
  "From AED {{amt}}/day incl. VAT": "ابتداءً من {{amt}} درهم/يوم شامل الضريبة",
  "Nothing matched — try a model name, or browse the": "لا شيء يطابق — جرّب اسم طراز، أو تصفّح",
  "full fleet": "الأسطول الكامل",
  "help centre": "مركز المساعدة",

  // ---------- NotFound ----------
  "This road doesn't exist — let's get you back on track.": "هذا الطريق غير موجود — دعنا نعيدك إلى المسار.",
  "The page you're after has moved, or never left the depot. Search the site or take one of the main roads below.":
    "الصفحة التي تبحث عنها انتقلت، أو لم تغادر المستودع أصلاً. ابحث في الموقع أو اسلك أحد الطرق الرئيسية أدناه.",
  "Search vehicles, articles, answers…": "ابحث في المركبات والمقالات والإجابات…",
  "My Account": "حسابي",
  "Back to booking": "العودة إلى الحجز",

  // ---------- Forgot / Reset password ----------
  "Reset your password.": "أعِد تعيين كلمة المرور.",
  "Enter the email on your account and we'll issue a reset link.": "أدخِل البريد المسجّل في حسابك وسنُصدر رابط إعادة تعيين.",
  "Demo": "تجريبي",
  "Email sending is mocked — the reset email is delivered to the admin Outbox (Account → Outbox).":
    "إرسال البريد محاكى — يُسلَّم بريد إعادة التعيين إلى صندوق صادر المشرف (الحساب ← الصادر).",
  "Issue reset link": "إصدار رابط إعادة التعيين",
  "Remembered it?": "تذكّرتها؟",
  "Back to sign in": "العودة إلى تسجيل الدخول",
  "Choose a new password.": "اختر كلمة مرور جديدة.",
  "Passwords don't match": "كلمتا المرور غير متطابقتين",
  "This link is missing its token.": "هذا الرابط ينقصه الرمز.",
  "Request a new reset link": "اطلب رابط إعادة تعيين جديداً",
  "New password (min 8 characters)": "كلمة مرور جديدة (8 أحرف على الأقل)",
  "Confirm new password": "تأكيد كلمة المرور الجديدة",
  "Update password": "تحديث كلمة المرور",

  // ---------- AuthCallback ----------
  "Signing you in…": "جارٍ تسجيل دخولك…",

  // ---------- Legal (chrome only; dense bodies fall back to English) ----------
  "Terms & Conditions": "الشروط والأحكام",
  "Privacy Policy": "سياسة الخصوصية",
  "Cookie Policy": "سياسة ملفات تعريف الارتباط",
  "Last updated: June 2026": "آخر تحديث: يونيو 2026",
  "and": "و",
  "Locations": "المواقع",

  // ---------- IncludedTable ----------
  "Comprehensive insurance with CDW": "تأمين شامل مع إعفاء أضرار الاصطدام",
  "Third-party cover up to AED 3.65 million": "تغطية طرف ثالث حتى 3.65 مليون درهم",
  "Unlimited UAE kilometres on daily & weekly rentals": "كيلومترات غير محدودة داخل الإمارات في الإيجارات اليومية والأسبوعية",
  "3,000 km/month on monthly rentals (4,000 km +12% · 5,000 km +22%)": "3,000 كم/شهر في الإيجارات الشهرية (4,000 كم +12% · 5,000 كم +22%)",
  "Routine maintenance & servicing": "الصيانة والخدمة الدورية",
  "Free replacement on genuine breakdown": "استبدال مجاني عند عطل حقيقي",
  "VAT shown in every displayed price": "الضريبة ظاهرة في كل سعر معروض",
  "Tolls — Salik in Dubai · Darb in Abu Dhabi (+25% admin fee)": "الرسوم — سالك في دبي · درب في أبوظبي (+ رسم إداري 25%)",
  "Fuel — return at handover level or cost +15%": "الوقود — أعِد المركبة بمستوى التسليم أو التكلفة +15%",
  "Traffic fines (+10% admin fee)": "المخالفات المرورية (+ رسم إداري 10%)",
  "Excess kilometres (AED 0.50–0.75/km + VAT)": "الكيلومترات الزائدة (0.50–0.75 درهم/كم + الضريبة)",
  "Airport surcharge where applicable (AED 52.50 incl. VAT)": "رسم إضافي للمطار عند اللزوم (52.50 درهم شامل الضريبة)",
  "Optional extras (child seats, additional drivers)": "إضافات اختيارية (مقاعد أطفال، سائقون إضافيون)",

  // ---------- Blog (chrome; article content stays English) ----------
  "The Europcar UAE Journal": "مجلة يوروبكار الإمارات",
  "Stories from the road.": "حكايات من الطريق.",
  "Travel guides, honest rental tips, company news and our sustainability journey — written the way we'd tell a friend.":
    "أدلة سفر، ونصائح إيجار صادقة، وأخبار الشركة، ورحلتنا نحو الاستدامة — مكتوبة كما نحكيها لصديق.",
  "Search articles…": "ابحث في المقالات…",
  "No articles match your search.": "لا توجد مقالات تطابق بحثك.",
  "Read": "اقرأ",
  "min": "دقيقة",
  "Travel Guides": "أدلة السفر",
  "Rental Tips": "نصائح الإيجار",
  "Company News": "أخبار الشركة",
  "Sustainability": "الاستدامة",

  // ---------- Partners (B2B lead hub) ----------
  "B2B Partner Hub": "مركز الشركاء للأعمال",
  "Grow with Europcar UAE": "انمُ مع يوروبكار الإمارات",
  "Dedicated RateCodes, volume booking, seasonal discounts and priority fleet access across 8 partner programs. Leads are routed to our partnerships CRM.":
    "رموز أسعار مخصّصة، وحجوزات بالجملة، وخصومات موسمية، وأولوية في الوصول إلى الأسطول عبر 8 برامج للشركاء. تُوجَّه الطلبات إلى نظام إدارة علاقات الشركاء لدينا.",
  "Hotels": "الفنادق",
  "Corporates": "الشركات",
  "Travel Agencies": "وكالات السفر",
  "Insurance": "التأمين",
  "Embassies": "السفارات",
  "Government": "الجهات الحكومية",
  "Dealerships": "الوكالات",
  "Brokers": "الوسطاء",
  "Guest transport & concierge rentals with commission-based partner rates.": "نقل الضيوف وإيجارات الكونسيرج بأسعار شركاء قائمة على العمولة.",
  "Employee mobility, negotiated RateCodes and monthly consolidated invoicing.": "تنقّل الموظفين، ورموز أسعار متفاوَض عليها، وفوترة شهرية موحّدة.",
  "Volume booking engine with agent portal access and instant confirmations.": "محرّك حجز بالجملة مع بوابة للوكلاء وتأكيدات فورية.",
  "Replacement vehicles for claims with priority fleet allocation.": "مركبات بديلة للمطالبات مع أولوية في تخصيص الأسطول.",
  "Diplomatic mobility programs with dedicated account management.": "برامج تنقّل دبلوماسية مع إدارة حسابات مخصّصة.",
  "Tendered fleet solutions compliant with UAE procurement standards.": "حلول أسطول عبر المناقصات متوافقة مع معايير المشتريات في الإمارات.",
  "Courtesy & service replacement cars for your workshop customers.": "سيارات مجاملة وبديلة للخدمة لعملاء ورشتك.",
  "Referral commissions and white-label booking integrations.": "عمولات إحالة وتكاملات حجز بعلامة بيضاء.",
  "Enquire": "استفسر",
  "Thank you! Our partnerships team will contact you.": "شكراً لك! سيتواصل معك فريق الشراكات لدينا.",
  "Enquiry received": "تم استلام الاستفسار",
  "Reference": "المرجع",
  "Our partnerships team will reach out within 1 business day. (CRM sync to Dynamics 365 mocked in demo.)":
    "سيتواصل معك فريق الشراكات خلال يوم عمل واحد. (مزامنة CRM مع Dynamics 365 محاكاة في العرض التجريبي.)",
  "Submit another enquiry": "إرسال استفسار آخر",
  "Become a partner": "كن شريكاً",
  "Tell us about your business — we'll tailor a program for you.": "أخبِرنا عن عملك — وسنصمّم برنامجاً يناسبك.",
  "Partner category *": "فئة الشريك *",
  "Company name *": "اسم الشركة *",
  "Contact person *": "الشخص المسؤول *",
  "Business email *": "البريد الإلكتروني للعمل *",
  "Tell us about your needs": "أخبِرنا عن احتياجاتك",
  "Expected monthly volume, locations, vehicle categories…": "الحجم الشهري المتوقّع، والمواقع، وفئات المركبات…",
  "Submit enquiry": "إرسال الاستفسار",

  // ---------- PartnerWithUs / PartnerCategory (chrome; deep content falls back to English) ----------
  "Choose your category": "اختر فئتك",
  "Find your partnership": "اعثر على شراكتك",
  "Eight proven programme types — pick the one closest to your business.": "ثمانية أنواع برامج مُجرّبة — اختر الأقرب إلى عملك.",
  "Explore": "استكشف",
  "Why partner with Europcar": "لماذا الشراكة مع يوروبكار",
  "Partner FAQ": "الأسئلة الشائعة للشركاء",
  "All partnerships": "كل الشراكات",
  "Partnership models": "نماذج الشراكة",
  "The journey": "الرحلة",
  "What you get": "ما الذي تحصل عليه",
  "Our commitments": "التزاماتنا",
  "For your customers:": "لعملائك:",
  "Start the conversation": "ابدأ الحوار",
  "No commercial terms, trade rates or commissions are published — everything is agreed privately per partnership.":
    "لا تُنشَر أي شروط تجارية أو أسعار أو عمولات — يُتَّفق على كل شيء بشكل خاص لكل شراكة.",
  "No API or technical build is promised upfront; integration is scoped only where it adds proven value.":
    "لا يُوعَد بأي واجهة برمجية أو بناء تقني مسبقاً؛ ويُحدَّد نطاق التكامل فقط حيث يضيف قيمة مثبتة.",
  "Your customer data is used solely to operate the agreed programme — nothing more.":
    "تُستخدَم بيانات عملائك فقط لتشغيل البرنامج المتّفق عليه — لا أكثر.",

  // ---------- Account (chrome + tabs) ----------
  "My account": "حسابي",
  "Overview": "نظرة عامة",
  "History": "السجل",
  "Current Agreement": "الاتفاقية الحالية",
  "Vehicle Documentation": "مستندات المركبة",
  "Service Requests": "طلبات الخدمة",
  "Billing & Disputes": "الفوترة والنزاعات",
  "Profile": "الملف الشخصي",
  "Doc Review": "مراجعة المستندات",
  "Blog CMS": "إدارة المدونة",
  "Fleet Gallery": "معرض الأسطول",
  "Reviews": "التقييمات",
  "Partner Leads": "عملاء الشركاء",
  "Outbox": "الصادر",
  "Subscription extended by 1 month": "تم تمديد الاشتراك شهراً واحداً",
  "Booking cancelled": "تم إلغاء الحجز",
  "Booking extended": "تم تمديد الحجز",
  "Profile updated": "تم تحديث الملف الشخصي",
  "No bookings yet.": "لا حجوزات بعد.",
  "Book your first car": "احجز سيارتك الأولى",
  "No active or upcoming rental agreement right now.": "لا توجد اتفاقية إيجار سارية أو قادمة الآن.",
  "Book your next car": "احجز سيارتك التالية",
  "Your active and upcoming rentals — expand a booking to check in, extend, or download the rental agreement and invoice.":
    "إيجاراتك السارية والقادمة — وسّع أي حجز لتسجيل الوصول أو التمديد أو تحميل عقد الإيجار والفاتورة.",

  // ---------- PartnerEnquiryForm ----------
  "Please tell us your name": "يرجى إخبارنا باسمك",
  "Enter a valid email address": "أدخِل بريداً إلكترونياً صحيحاً",
  "Enter a valid phone number": "أدخِل رقم هاتف صحيحاً",
  "Company or organisation is required": "اسم الشركة أو المؤسسة مطلوب",
  "Choose your primary market": "اختر سوقك الرئيسي",
  "Choose your expected volume": "اختر الحجم المتوقّع",
  "Tell us a little more — at least 20 characters": "أخبِرنا أكثر قليلاً — 20 حرفاً على الأقل",
  "Please keep it under 1,500 characters": "يرجى إبقاؤها دون 1,500 حرف",
  "Please accept the privacy consent to continue": "يرجى قبول موافقة الخصوصية للمتابعة",
  "This field helps us route your enquiry": "يساعدنا هذا الحقل في توجيه استفسارك",
  "Thank you — we're on it.": "شكراً لك — نحن نعمل عليه.",
  "Explore the fleet": "استكشف الأسطول",
  "Return to partnerships": "العودة إلى الشراكات",
  "Partnership type": "نوع الشراكة",
  "Change": "تغيير",
  "Work email *": "بريد العمل *",
  "Company / organisation *": "الشركة / المؤسسة *",
  "Primary market *": "السوق الرئيسي *",
  "Monthly requirement *": "الاحتياج الشهري *",
  "Select…": "اختر…",
  "United Arab Emirates": "الإمارات العربية المتحدة",
  "GCC": "دول الخليج",
  "Europe": "أوروبا",
  "Asia": "آسيا",
  "Africa": "إفريقيا",
  "Americas": "الأمريكتان",
  "Global": "عالمي",
  "Under 10 vehicles / month": "أقل من 10 مركبات / شهر",
  "10–50 vehicles / month": "10–50 مركبة / شهر",
  "50–200 vehicles / month": "50–200 مركبة / شهر",
  "200+ vehicles / month": "200+ مركبة / شهر",
  "Not sure yet": "غير متأكّد بعد",
  "No account needed. No sensitive documents collected at this stage.": "لا حاجة لحساب. ولا تُجمَع مستندات حساسة في هذه المرحلة.",

  // ---------- CheckIn ----------
  "Driver details": "بيانات السائق",
  "Rental terms": "شروط الإيجار",
  "Signature": "التوقيع",
  "Back to My Bookings": "العودة إلى حجوزاتي",
  "Check-in complete": "اكتمل تسجيل الوصول",
  "Your digital rental agreement is signed and ready. Show your booking reference at pickup or delivery.":
    "تم توقيع عقد الإيجار الرقمي وهو جاهز. أظهِر رقم مرجع حجزك عند الاستلام أو التوصيل.",
  "Rental agreement": "عقد الإيجار",
  "Booking {{ref}}": "الحجز {{ref}}",
  "Online check-in is not available for this booking ({{status}}).": "تسجيل الوصول عبر الإنترنت غير متاح لهذا الحجز ({{status}}).",
  "Online check-in": "تسجيل الوصول عبر الإنترنت",
  "Rental terms & conditions": "شروط وأحكام الإيجار",
  "I have read and accept the rental terms & conditions and confirm the driver details are accurate.":
    "لقد قرأت شروط وأحكام الإيجار وأوافق عليها، وأؤكّد أنّ بيانات السائق صحيحة.",
  "Back": "رجوع",
  "Continue to signature": "المتابعة إلى التوقيع",
  "Digital signature": "التوقيع الرقمي",
  "Your signature will be attached to rental agreement (Kiosk API — mocked in demo).":
    "سيُرفَق توقيعك بعقد الإيجار (واجهة الكشك — محاكاة في العرض التجريبي).",
  "Sign & complete check-in": "وقّع وأكمِل تسجيل الوصول",
  "Driving license number *": "رقم رخصة القيادة *",
  "Nationality *": "الجنسية *",
  "e.g. United Arab Emirates": "مثال: الإمارات العربية المتحدة",
  "Date of birth (optional)": "تاريخ الميلاد (اختياري)",
  "Vehicle is rented per the confirmed category — the exact model may vary (\"or similar\" policy).":
    "تُؤجَّر المركبة وفق الفئة المؤكّدة — وقد يختلف الطراز الدقيق (سياسة \"أو ما يماثله\").",
  "Minimum driver age is 21. Ages 21–24 carry a young driver surcharge (already included in your total).":
    "الحد الأدنى لسن السائق 21. وتُطبَّق رسوم سائق صغير على الأعمار 21–24 (مشمولة بالفعل في إجماليك).",
  "Included mileage per the booking; excess mileage charged at AED 0.50–0.75/km + 5% VAT per tier.":
    "الكيلومترات المشمولة حسب الحجز؛ وتُحتسَب الزائدة بـ 0.50–0.75 درهم/كم + 5% ضريبة حسب الشريحة.",
  "Security deposit: credit card pre-authorization or debit card charge as disclosed at checkout (waived with NDW).":
    "مبلغ الضمان: حجز مسبق على بطاقة الائتمان أو خصم على بطاقة الخصم كما هو معلن عند الدفع (مُعفى مع إعفاء بدون تأمين).",
  "Fuel policy: return with the same fuel level as at handover; toll crossings (Salik/Darb) are billed after your rental.":
    "سياسة الوقود: أعِد المركبة بمستوى الوقود نفسه عند التسليم؛ وتُحتسَب عبورات الرسوم (سالك/درب) بعد الإيجار.",
  "Traffic fines incurred during the rental period are the renter's responsibility plus an admin fee.":
    "المخالفات المرورية خلال فترة الإيجار مسؤولية المستأجر بالإضافة إلى رسم إداري.",
  "Report any accident immediately via 800-EUROPCAR and file a police report where required by UAE law.":
    "أبلِغ عن أي حادث فوراً عبر 800-EUROPCAR وقدّم بلاغاً للشرطة حيثما يتطلّب قانون الإمارات.",

  // ---------- ReportAccident ----------
  "Report an accident": "الإبلاغ عن حادث",
  "Submitted to the Accident Report API (mocked in demo).": "يُرسَل إلى واجهة تقارير الحوادث (محاكاة في العرض التجريبي).",
  "Select a booking": "اختر حجزاً",
  "Report submitted": "تم إرسال البلاغ",
  "Accident report reference": "مرجع بلاغ الحادث",
  "Back to My Account": "العودة إلى حسابي",
  "You need an active booking to report an accident.": "تحتاج إلى حجز ساري لتُبلِغ عن حادث.",
  "Book a car": "احجز سيارة",
  "In an emergency call 999 first.": "في حالات الطوارئ اتصل بـ 999 أولاً.",
  "Roadside assistance:": "المساعدة على الطريق:",
  "Check safety, obtain the final authorized police report (not just a reference number), and never admit fault at the scene.":
    "تأكّد من السلامة، واحصل على تقرير الشرطة النهائي المعتمد (لا مجرد رقم مرجع)، ولا تعترف بالخطأ في موقع الحادث أبداً.",
  "Accident details": "تفاصيل الحادث",
  "Booking *": "الحجز *",
  "Date & time of accident *": "تاريخ ووقت الحادث *",
  "Location *": "الموقع *",
  "e.g. Sheikh Zayed Road, exit 42": "مثال: شارع الشيخ زايد، مخرج 42",
  "What happened? *": "ماذا حدث؟ *",
  "Who was at fault?": "من كان المخطئ؟",
  "Third party at fault": "الطرف الآخر مخطئ",
  "I was at fault": "أنا كنت المخطئ",
  "Shared fault": "خطأ مشترك",
  "Unknown / hit and run": "غير معروف / اصطدام وهروب",
  "Damage location": "موقع الضرر",
  "Front": "الأمام",
  "Rear": "الخلف",
  "Left side": "الجانب الأيسر",
  "Right side": "الجانب الأيمن",
  "Roof": "السقف",
  "Windshield": "الزجاج الأمامي",
  "Interior": "الداخلية",
  "Multiple areas": "مناطق متعدّدة",
  "Damage description": "وصف الضرر",
  "e.g. dented front bumper, broken left headlight": "مثال: صدمة في المصد الأمامي، كسر في المصباح الأيسر",
  "Damage photos": "صور الأضرار",
  "Add photos (max 6)": "أضِف صوراً (6 كحد أقصى)",
  "Police involved": "الشرطة مشارِكة",
  "Police report number": "رقم بلاغ الشرطة",
  "Police report file (image/PDF)": "ملف بلاغ الشرطة (صورة/PDF)",
  "Insurance claims require the": "تتطلّب مطالبات التأمين",
  "final authorized report": "التقرير النهائي المعتمد",
  "— a reference number alone is not sufficient.": "— ولا يكفي رقم المرجع وحده.",
  "Third party involved": "طرف آخر مشارِك",
  "Driver name": "اسم السائق",
  "Company (if commercial)": "الشركة (إن كانت تجارية)",
  "Vehicle details (make, plate)": "بيانات المركبة (الصنع، اللوحة)",
  "Insurance policy no.": "رقم وثيقة التأمين",
  "Injuries were reported": "تم الإبلاغ عن إصابات",
  "Remarks / other details": "ملاحظات / تفاصيل أخرى",
  "Anything else we should know…": "أي شيء آخر ينبغي أن نعرفه…",
  "Submit accident report": "إرسال بلاغ الحادث",
};

export default ar;
